// src/components/Navbar.js
import React, { useState, useEffect, useContext } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebaseClient';
import { CustomerContext } from '../App';
import './Navbar.css';
import logo from '../assets/logo.jpg';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isDemo = location.pathname.startsWith('/demo');
  const prefix = isDemo ? '/demo' : '';
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  const { selectedCustomerId, setSelectedCustomerId } = useContext(CustomerContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [customers, setCustomers] = useState([]);

  const adminEmails = ['admin@prosperly.com', 'prosperly.info@gmail.com'];

  useEffect(() => {
    const user = auth.currentUser;
    if (user && adminEmails.includes(user.email)) {
      setIsAdmin(true);
      fetch(`${API_URL}/api/test-firebase`)
        .then(res => res.json())
        .then(customersFromApi => {
          // Der Server liefert direkt ein Array von Kunden
          setCustomers(customersFromApi);
        })
        .catch(err => console.error('Error loading customers:', err));
    } else {
      setIsAdmin(false);
    }
  }, [API_URL]);

  const handleHamburgerClick = () => {
    setMenuOpen(open => !open);
  };

  const handleMenuItemClick = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-header">
          <div className="navbar-logo" onClick={() => navigate(prefix + '/dashboard')}>
            <img src={logo} alt="Prosperly Logo" className="logo-img" />
            <span className="logo-text">prosperly</span>
          </div>

          <div className={`hamburger-menu ${menuOpen ? 'open' : ''}`} onClick={handleHamburgerClick}>
            <div />
            <div />
            <div />
          </div>

          <ul className="navbar-menu">
            <li><NavLink to={`${prefix}/dashboard`} end>Dashboard</NavLink></li>
            <li><NavLink to={`${prefix}/properties`}>Wohnungen</NavLink></li>
            <li><NavLink to={`${prefix}/documents`}>Dokumente</NavLink></li>
            <li><NavLink to={`${prefix}/contact`}>Kontakt</NavLink></li>
            <li><NavLink to={`${prefix}/settings`}>Einstellungen</NavLink></li>
            {isAdmin && (
              <li>
                <select
                  value={selectedCustomerId || ''}
                  onChange={e => setSelectedCustomerId(e.target.value)}
                >
                  <option value="">Kunden auswählen</option>
                  {customers.map(cust => (
                    <option key={cust.id} value={cust.id}>
                      {cust.registeredEmail || cust.id}
                    </option>
                  ))}
                </select>
              </li>
            )}
          </ul>
        </div>
      </nav>

      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li onClick={handleMenuItemClick}><NavLink to={`${prefix}/dashboard`} end>Dashboard</NavLink></li>
          <li onClick={handleMenuItemClick}><NavLink to={`${prefix}/properties`}>Wohnungen</NavLink></li>
          <li onClick={handleMenuItemClick}><NavLink to={`${prefix}/documents`}>Dokumente</NavLink></li>
          <li onClick={handleMenuItemClick}><NavLink to={`${prefix}/contact`}>Kontakt</NavLink></li>
          <li onClick={handleMenuItemClick}><NavLink to={`${prefix}/settings`}>Einstellungen</NavLink></li>
          {isAdmin && (
            <li>
              <select
                value={selectedCustomerId || ''}
                onChange={e => {
                  setSelectedCustomerId(e.target.value);
                  handleMenuItemClick();
                }}
              >
                <option value="">Kunden auswählen</option>
                {customers.map(cust => (
                  <option key={cust.id} value={cust.id}>
                    {cust.registeredEmail || cust.id}
                  </option>
                ))}
              </select>
            </li>
          )}
        </ul>
      </div>
    </>
  );
}
